<!-- Copyright (c) 2018-2026, NVIDIA CORPORATION.  All rights reserved.
NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

<div
    class="carousel-container"
    #container
    [class.mobile-view]="mobileMode"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    dir="{{ carouselDirection }}"
>
    <div class="carousel-wrapper" #wrapper>
        <!--
    Sets buffer to ensure that at least one item is rendered beyond the scroll viewport.
    This is required for spatial navigation's focus search, which only searchs items inserted in DOM.
    -->
        <cdk-virtual-scroll-viewport
            class="carousel-inner"
            [style.height.px]="itemHeight"
            #carousel
            orientation="horizontal"
            [itemOffsets]="itemOffsets"
            [minBufferPx]="itemWidth"
            [maxBufferPx]="2.1 * itemWidth"
            nvSpatialNavigationGroup
            navigateAction="focus"
            [enableKeyThrottle]="true"
            [enableSmoothScrolling]="false"
            [spacingLeft]="spatialNavigationSpacingLeft"
            [spacingRight]="spatialNavigationSpacingRight"
            nvFocusBack
            [enableFocusBack]="!isFirstTileFocused"
            nvFast1DSpatialNavigation
            [containFocus]="true"
            [isRTL]="carouselDirection === 'rtl'"
        >
            <div
                *cdkVirtualFor="
                    let item of items;
                    let index = index;
                    let first = first;
                    let last = last;
                    trackBy: tileIdentity
                "
                #carouselItem
                class="item-container"
                [class.first]="first"
                [class.last]="last"
                [style.height.px]="this.itemHeight"
                (focusin)="onTileFocused(index)"
                (focusout)="onTileFocusOut()"
                nvFastSpatialNavigationItem
            >
                <ng-template
                    [ngTemplateOutlet]="template"
                    [ngTemplateOutletContext]="{ $implicit: item, index: index }"
                ></ng-template>
            </div>
        </cdk-virtual-scroll-viewport>
    </div>
    @if (enableButtons && carouselButtonsVisibility) {
        <button
            mat-button
            class="carousel-button carousel-button-prev"
            (click)="moveLeft($event)"
            [ngClass]="{ hidden: !showLeftCarouselButton }"
            [attr.aria-label]="'marquee.previous' | translate"
        >
            <mat-icon class="carousel-button-icon" svgIcon="lt_arrow"></mat-icon>
        </button>
        <button
            mat-button
            class="carousel-button carousel-button-next"
            (click)="moveRight($event)"
            [ngClass]="{ hidden: !showRightCarouselButton }"
            [attr.aria-label]="'marquee.next' | translate"
        >
            <mat-icon class="carousel-button-icon" svgIcon="rt_arrow"></mat-icon>
        </button>
    }
</div>
